import React, { ReactNode } from "react";

type Props = {
    children: ReactNode;
    className?: string;
    style?: any;
};

export default function Section(props: Props)
{
    const className = props.className === undefined ? null : props.className;
    const style = props.style == undefined ? null : props.style;

    return (
        <section className={className} style={style}>
            {props.children}
        </section>
    );
}